import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getAppointmentAttachments} from '../../services/getAppointmentAttachments';

export const useGetAppointmentAttachmentsQuery = (nuControle: string) =>
	useQuery({
		queryKey: [QUERY_KEYS.APPOINTMENT_ATTACHMENTS, nuControle],
		queryFn: () => getAppointmentAttachments({nuControle}),
		enabled: !!nuControle,
	});
